import { AfterViewInit, Component, OnInit, PLATFORM_ID, inject, Inject } from '@angular/core';
import { RouterOutlet } from '@angular/router'
import { AuthStateService } from '@core/auth/auth-state.service'
import { PageViewTrackingService } from '@core/services/page-view-tracking.service'
import { LayoutCenteredComponent } from '@main/layout/layout-centered/layout-centered.component'
import { LayoutCheckoutComponent } from '@main/layout/layout-checkout/layout-checkout.component'
import { LayoutDefaultComponent } from '@main/layout/layout-default/layout-default.component'
import { PageLayout } from '@main/layout/page-layout.enum'
import { PageLayoutService } from '@main/layout/page-layout.service'
import { NgxSonnerToaster } from 'ngx-sonner'

import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { TranslocoService } from '@jsverse/transloco'
import { delay, delayWhen, interval, of, timer } from 'rxjs'
import * as CookieConsent from 'vanilla-cookieconsent'
import { environment } from '@environment/environment';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [
        RouterOutlet,
        NgxSonnerToaster,
        LayoutDefaultComponent,
        LayoutCenteredComponent,
        LayoutCheckoutComponent,
    ],
})
export class AppComponent implements OnInit, AfterViewInit {
    private authStateService = inject(AuthStateService)
    private pageViewTracking = inject(PageViewTrackingService)
    private platformId = inject(PLATFORM_ID)
    private translocoService = inject(TranslocoService)
    layoutService = inject(PageLayoutService)
    readonly PageLayout = PageLayout

    constructor (@Inject(DOCUMENT) private document: Document,) {

    }

    ngOnInit(): void {
        this.authStateService.init()
        this.pageViewTracking.init()
    }

    ngAfterViewInit(): void {
        if (isPlatformBrowser(this.platformId)) {
            CookieConsent.run({
                guiOptions: {
                    consentModal: {
                        layout: 'bar inline',
                        position: 'bottom',
                        flipButtons: false,
                        equalWeightButtons: true,
                    },
                    preferencesModal: {
                        layout: 'box',
                        flipButtons: false,
                        equalWeightButtons: true,
                    },
                },
                categories: {
                    necessary: {
                        enabled: true,
                        readOnly: true,
                    },
                    analytics: {},
                },
                language: {
                    default: this.translocoService.getDefaultLang(),
                    autoDetect: 'document',
                    translations: {
                        en_US: `${environment.siteUrl}/assets/cookie/en_US.json`,
                        sr_RS: `${environment.siteUrl}/assets/cookie/sr_RS.json`,
                    },
                },
            })

            const script = this.document.createElement("script");
            script.type = 'text/javascript';
            script.innerHTML = ` ;(window.heap = window.heap || []),
                (heap.load = function (e, t) {
                    ;(window.heap.appid = e), (window.heap.config = t = t || {})
                    var r = document.createElement('script')
                    ;(r.type = 'text/javascript'),
                        (r.async = !0),
                        (r.src = 'https://cdn.heapanalytics.com/js/heap-' + e + '.js')
                    var a = document.getElementsByTagName('script')[0]
                    a.parentNode.insertBefore(r, a)
                    for (
                        var n = function (e) {
                                return function () {
                                    heap.push([e].concat(Array.prototype.slice.call(arguments, 0)))
                                }
                            },
                            p = [
                                'addEventProperties',
                                'addUserProperties',
                                'clearEventProperties',
                                'identify',
                                'resetIdentity',
                                'removeEventProperty',
                                'setEventProperties',
                                'track',
                                'unsetEventProperty',
                            ],
                            o = 0;
                        o < p.length;
                        o++
                    )
                        heap[p[o]] = n(p[o])
                });
                 heap.load('${environment.heapAppId}');
                `
            const lastScript = this.document.getElementsByTagName('script')[0];
            lastScript.parentNode?.insertBefore(script, lastScript);
        }
    }
}
